(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/ticket-skin-image.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/ticket-skin-image.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useMemo,
  memo
} = React;
const {
  Image
} = svs.content.image_v2;

const TicketSkinImage = memo(_ref => {
  let {
    image,
    number,
    onLoadCallback,
    fallbackImage
  } = _ref;
  return React.createElement(Image, {
    cssSelectors: "ticket-skin-shadow",
    fallbackImage: fallbackImage,
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: "Lott-".concat(number)
    }),
    onLoadCallback: onLoadCallback
  });
});
const PreloadSkinImages = _ref2 => {
  let {
    ticketInfo,
    onLoaded
  } = _ref2;
  const skinsToRender = useMemo(() => {
    let numberOfImagesNotLoaded = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.variations;
    const decreaseNumberOfImagesNotLoaded = () => {
      if (--numberOfImagesNotLoaded === 0) {
        onLoaded === null || onLoaded === void 0 || onLoaded();
      }
    };
    const skinsToRender = [];
    const fallbackImage = "".concat(location.origin, "/images/tickets/dummy-fallback.svg");
    for (let i = 0; i < (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.variations); i++) {
      const skin = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.skins[i];
      skinsToRender.push(React.createElement("div", {
        key: skin.url
      }, React.createElement(TicketSkinImage, {
        fallbackImage: fallbackImage,
        image: skin.image,
        number: i + 1,
        onLoadCallback: decreaseNumberOfImagesNotLoaded
      })));
    }
    return skinsToRender;
  }, [ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type]);
  return React.createElement("div", {
    style: {
      display: 'none'
    }
  }, skinsToRender);
};
setGlobal('svs.tickets.play.components.TicketSkinImage', TicketSkinImage);
setGlobal('svs.tickets.play.components.PreloadSkinImages', PreloadSkinImages);

 })(window);